/* eslint eqeqeq: 0 */
import * as React from 'react';
import $ from 'jquery';
import { RCUtils } from './../../RCUtils';
import Formatters from '../../actions/Formatters';
import Excel from '../../actions/ExportToExcel.js';
import { PopupWindow } from '../sharedcomponents/PopupWindow';
import * as RCNGWindow from './../sharedcomponents/ConfirmationWindow';
import DateFormat from 'dateformat';
var Config: any = require('../../Config.json');

interface SendEmailState {
    EmailFilters: EmailFields;
    okMethod: Function;
    cancelMethod: Function;
    confirmationMsg: string;
    dateTime: any;
    confirmOk: boolean;
    gridApiParams: any;
}

var currentDateTime;
var self;
var ProcessfirstCellOnlyRowIndex = -1;

export class SendEmailControl extends React.Component<any, SendEmailState> {
    myRequest: any;
    constructor(props: any) {
        super(props);
        var filterSet = this.clearEmailFiltersGenset();
        this.state = { EmailFilters: filterSet, okMethod: Function, cancelMethod: Function, confirmationMsg: '', dateTime: currentDateTime, confirmOk: false, gridApiParams: this.props.gridApiParams };
        self = this;

        this.getGroupDisplayValueName = this.getGroupDisplayValueName.bind(this);
    }

    FromEmailchange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.EmailFilters;
        var Value: string = event.currentTarget.value;
        filters.SelectedFrom = Value;
        this.setState({
            EmailFilters: filters
        });
    }

    Subjectchange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.EmailFilters;
        var Value: string = event.currentTarget.value;
        filters.SelectedSubject = Value;
        this.setState({
            EmailFilters: filters
        });
    }

    ToEmailchange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.EmailFilters;
        var Value: string = event.currentTarget.value;
        filters.SelectedTo = Value;
        this.setState({
            EmailFilters: filters
        });
    }

    Messagechange(event: React.FormEvent<HTMLTextAreaElement>) {
        var filters = this.state.EmailFilters;
        var Value: string = event.currentTarget.value;
        filters.SelectedMessage = Value;
        this.setState({
            EmailFilters: filters
        });
    }

    dateTypeFormatter(eventDate: Date) {
        var timeZoneOffset = JSON.parse(sessionStorage.getItem('UserInfo')).TimeZoneOffSet;
        var eventdttm = new Date();
        if (eventDate != null)
            eventdttm = new Date(eventDate.toString());
        var utc = eventdttm.getTime() + (eventdttm.getTimezoneOffset() * 60000);
        var prefDateTime = new Date(new Date(utc).getTime() + (60000 * (parseInt(timeZoneOffset))));
        return DateFormat(prefDateTime, 'mm/dd/yyyy HH:MM:ss');
    }

    clearEmailFiltersGenset() {
        currentDateTime = this.dateTypeFormatter((new Date()));
        var filters: EmailFields = {
            SelectedTo: "", SelectedFrom: Config.DefaultEmailAddress, SelectedSubject: "", SelectedAttachment: "", SelectedMessage: "", SelectedForm: ""
        };
        this.setState({
            EmailFilters: filters, confirmOk: false, dateTime: currentDateTime
        });
        return filters;
    }

    componentWillReceiveProps(nextprops: any) {
        this.clearEmailFiltersGenset();
        RCNGWindow.ConfirmWindow.close();
    }

    closeConfirmation() {
        this.setState({
            confirmOk: false
        });
        RCNGWindow.ConfirmWindow.close();
    }

    SendEmailExportAPI() {
        this.setState({ gridApiParams: this.props.gridApiParams });
        var IsGroupsExist = this.props.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getRowGroupColumns().length > 0 ? true : false;
        if (IsGroupsExist) {
            var uri = this.props.gridApiParams.gridOptionsWrapper.gridOptions.api.getDataAsCsv(
                {
                    columnGroups: false,
                    allColumns: true,
                    processGroupHeaderCallback: this.myGroupHeaderCallback, processHeaderCallback: this.myHeaderCallback,
                    processRowGroupCallback: this.myRowGroupCallback, processCellCallback: this.myCellCallback,
                    //fileName: this.getFileName(this.GetExportFileName()),

                });
        } else {
            var allColumns = this.props.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
            for (var i = allColumns.length - 1; i >= 0; i--) {
                if (allColumns[i].colDef.headerName === 'Group') {
                    allColumns.splice(i, 1);
                }
            }
            var uri = this.props.gridApiParams.gridOptionsWrapper.gridOptions.api.getDataAsCsv(
                {
                    columnGroups: true,
                    columnKeys: allColumns,
                    skipGroups: true,
                    processGroupHeaderCallback: this.myGroupHeaderCallback, processHeaderCallback: this.myHeaderCallback,
                    processRowGroupCallback: this.myRowGroupCallback, processCellCallback: this.myCellCallback,
                    //fileName: this.getFileName(this.GetExportFileName()),

                });
        }     
        //var uri = this.props.gridApiParams.gridOptionsWrapper.gridOptions.api.getDataAsExcel(
        //    {
        //        columnGroups: false,
        //        allColumns: true,
        //        processGroupHeaderCallback: this.myGroupHeaderCallback, processHeaderCallback: this.myHeaderCallback,
        //        processRowGroupCallback: this.myRowGroupCallback, processCellCallback: this.myCellCallback,
        //        //fileName: this.getFileName(this.GetExportFileName()),

        //    });

        return uri;
    }
    SendEmailExportAPIForAction() {

        this.setState({ gridApiParams: this.props.gridApiParams });
        var IsGroupsExist = this.props.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getRowGroupColumns().length > 0 ? true : false;
        if (IsGroupsExist) {
            var uri = this.props.gridApiParams.gridOptionsWrapper.gridOptions.api.getDataAsCsv(
                {
                    columnGroups: false,
                    allColumns: true,
                    onlySelected: true,
                    processGroupHeaderCallback: this.myGroupHeaderCallback, processHeaderCallback: this.myHeaderCallback,
                    processRowGroupCallback: this.myRowGroupCallback, processCellCallback: this.myCellCallback,
                    //fileName: this.getFileName(this.GetExportFileName()),

                });
        } else {
            var allColumns = this.props.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
            for (var i = allColumns.length - 1; i >= 0; i--) {
                if (allColumns[i].colDef.headerName === 'Group') {
                    allColumns.splice(i, 1);
                }
            }
            var uri = this.props.gridApiParams.gridOptionsWrapper.gridOptions.api.getDataAsCsv(
                {
                    columnGroups: true,
                    columnKeys: allColumns,
                    skipGroups: true,
                    onlySelected: true,
                    processGroupHeaderCallback: this.myGroupHeaderCallback, processHeaderCallback: this.myHeaderCallback,
                    processRowGroupCallback: this.myRowGroupCallback, processCellCallback: this.myCellCallback,
                    //fileName: this.getFileName(this.GetExportFileName()),

                });
        }

        return uri;
    }
    getGroupDisplayValueName(params) {

        if (params !== undefined && params !== null) {

            var fieldName = params.node.field;
            var fieldValue = params.node.key;

            //var colDef = params.node.columnApi.columnController.rowGroupColumns.filter(x => x.colId === fieldName);
            //var columnDisplayName = colDef[0].colDef.headerName;
            var columnDisplayName = params.node.rowGroupColumn.colDef.headerName;//WI 26719

            if (fieldValue.toString().trim() === "-999" && (fieldName === 'BatteryVoltage' || fieldName === 'DoorSensorBatteryVoltage'))
                return "*No " + columnDisplayName;

            if (fieldValue === "-NA-" || fieldValue === "null")
                return "*No " + columnDisplayName;

            if (fieldValue.toString().trim() === "-999")
                return "OOR";

            switch (fieldName) {
                case "IgnitionOn":
                    return Formatters.GensetSwitchFormatterGroupingExcel(fieldValue);
                case "GensetRunning":
                    return Formatters.EngineSortingFormatterGroupingExcel(fieldValue);
                case 'UnitEventDTTM': case 'DataLoggerDtm': case 'ModifiedDTTM': case 'EventDTTM': case 'R_EventDTTM': case 'R_ModifiedDTTM': case 'DLEventDTTM': case 'InsertedDttm': case 'UpdatedDttm': case 'DoorEventDtm':
                    return Formatters.dateTypeFormatterGrouping(fieldValue);

                case 'DeviceTemp':
                    {
                        return Formatters.TemperatureFormatterExcelForDeviceTemp(params);
                    }
                case 'IsInsideGeofence': case 'IsActive': case 'StateCd':
                    {
                        return Formatters.YesNoConverterforExcel(fieldValue);
                    }

                case "DevicePowerSourceCd":
                    return Formatters.PowerStateFormatterGroupingForExcel(fieldValue);//done

                case 'BatteryVoltage':
                    {
                        return (fieldValue === "" || fieldValue === null || fieldValue === '-NA-' || fieldValue === '-999') ? '-NA-' : Formatters.BattVoltageSortingGrouping(fieldValue);
                    }
                case 'DoorSensorBatteryVoltage':
                    { 
                        var AssetType;
                        if (params.node.rowIndex != undefined && params.node.rowIndex != null
                            && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                            && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                            AssetType = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].AssetType;
                        }
                        if(AssetType != null && AssetType != undefined && AssetType.toString().toUpperCase().trim() == "D")
                            return (fieldValue == "" || fieldValue == null || fieldValue === '-NA-' || fieldValue === '-1') ? '-NA-' : Formatters.DoorBattPctSortingGrouping(fieldValue);
                    }
                case 'DeviceConfig': case 'GuestReeferMode':
                    {

                        return Formatters.GuestReeferModeFormatterForExcel(fieldValue);
                    }

                case 'RCDPOWERSOURCECD': if (params.value !== undefined && params.value !== null) return Formatters.rcdPowerSourceFormatterforExcel(fieldValue);

                case "CustomerName":
                    {
                        if (columnDisplayName === 'Assigned To')
                            return fieldValue === JSON.parse(sessionStorage.getItem('customerDetails')).CustomerName ? "-NA-" : fieldValue;
                        else
                            return fieldValue;
                    }
                case "ReeferOEMTypeCd": case "OEMTypeCD":// WI-26787
                    return Formatters.OEMTypeFormatterGrouping(fieldValue);
                case "RSSI":
                    return Formatters.RSSIFormatterGroupingForExcel(fieldValue);
                case "DeviceConfig":
                    return Formatters.GuestReeferModeGrouping(fieldValue);

                case "AssetType":
                    return Formatters.AssetTypeGrouping(fieldValue);
                case "GeofenceCategoryCd":
                    return Formatters.GeofenceTypeGrouping(fieldValue);
                case "FilerepositoryActionCD":
                    return Formatters.FileStatusGrouping(fieldValue);
                case "GPSCoords":
                    return Formatters.GPSCoordsFormatterForExcel(fieldValue, params);
                case "CCSeverityLevel":
                    return Formatters.CargoCareFormatterGroupingForExcel(fieldValue); //RCNG-241 Renamed Normal to Assigned
                case "DoorOpen":
                    return Formatters.DeviceDoorFormatterGrouping(fieldValue);
                default:
                    return fieldValue;

            }

        }
    }

    myCellCallback(params) {
        var returnValue;

        if (params.node.group && ProcessfirstCellOnlyRowIndex !== params.node.rowGroupIndex) {
            ProcessfirstCellOnlyRowIndex = params.node.rowGroupIndex
            if (params.node.key !== null && params.node.key !== undefined)
                return self.myRowGroupCallback(params);
        }

        if (params.node.group && params.column.colId === "0") {
            return self.myRowGroupCallback(params);
        }

        if (!params.node.group) {
            switch (params.column.colId) {

                case 'RCDID': case 'RCDId': case 'TowerBaseStationID': case 'ICCID': case 'MSISDN': case 'SIM_IMSI': case 'RcdID': case 'DeviceNumber':
                    {
                        if (params.value === undefined || params.value === "-NA-")
                            returnValue = "-NA-";
                        else
                            returnValue = '\t' + params.value;
                    }
                    break;
                case 'Name': case 'Tag': case 'Address': case 'ProfileCode': case 'ProfileCodeDescription': case 'InsertedBy': case 'UpdatedBy':
                    {
                        if (params.value !== undefined && params.value !== null)
                            returnValue = Formatters.stringTypeFormatterChildFormsNew(params.value);
                        else
                            returnValue = "-NA-";
                    }
                    break;
                case 'Coordinates':
                    if (params.value !== undefined && params.value !== null)
                        returnValue = Formatters.GeofenceCoordinatesFormatterforExcel(params.value);
                    else
                        returnValue = "-NA-";
                    break;
                case 'DeviceTemp':
                    {
                        if (params !== undefined && params !== null)
                            returnValue = Formatters.TemperatureFormatterExcelForDeviceTemp(params);
                        else
                            returnValue = "-NA-";
                    }
                    break
                case 'UnitEventDTTM': case 'DataLoggerDtm': case 'ModifiedDTTM': case 'EventDTTM': case 'R_EventDTTM': case 'R_ModifiedDTTM': case 'CreatedDTTM': case 'CreateDTTM': case 'StatusDate': case 'SubmittedOn': case 'TTL': case 'ExpirationTime': case 'PTRDateTime': case 'DLEventDTTM': case 'InsertedDttm': case 'UpdatedDttm': case 'DoorEventDtm':
                    {
                        //if (params.value != undefined && params.value != null)
                        returnValue = Formatters.dateTypeFormatterforExcel(params.value);
                    }
                    break

                case 'IsInsideGeofence': case 'IsActive': case 'HasFuelSensor': case 'HasOilPressureSwitch': case 'HasDoorSensor': case 'IsDeployed': case 'DCXDownloads': case 'StateCd':
                    {
                        //if (params.value !== undefined && params.value !== null)
                        returnValue = Formatters.YesNoConverterforExcel(params.value);
                    }
                    break
                case 'ReeferOEMTypeCd': case 'ÓEMTypeCD':
                    {
                        //if (params.value != undefined && params.value != null)
                        returnValue = Formatters.GetOEMTypeDescription(params.value);
                    }
                    break;

                case 'BatteryVoltage':
                    {
                        if (params.value !== undefined && params.value !== null)
                            returnValue = Formatters.BattVoltageFormatterforExcel(params.value);
                    }
                    break;
                 case 'DoorSensorBatteryVoltage':
                    {
                        if (params.node.data.AssetType != undefined && params.node.data.AssetType != null && params.node.data.AssetType.toString().toUpperCase().trim() == "D") {
                            if (params.node.data.DoorSensorBatteryVoltage != undefined && params.node.data.DoorSensorBatteryVoltage != null)
                                returnValue = Formatters.DoorBattPctFormatterforExcel(params.node.data.DoorSensorBatteryVoltage);
                        }
                        else {
                            if (params.value !== undefined && params.value !== null)
                                returnValue = Formatters.BattVoltageFormatterforExcel(params.value);
                        }
                    }
                    break;
                case 'DeviceConfig': case 'GuestReeferMode':
                    {
                        if (params.value !== undefined && params.value !== null)
                            returnValue = Formatters.GuestReeferModeFormatterForExcel(params.value);
                    }
                    break;

                case 'RCDPOWERSOURCECD': if (params.value !== undefined && params.value !== null) returnValue = Formatters.rcdPowerSourceFormatterforExcel(params.value);
                    break;
                case 'GeofenceCategoryCd': if (params.value !== undefined && params.value !== null) returnValue = Formatters.fenceTypeFormatterForExcel(params.value);
                    break;

                case 'GPSLastLock': if (params.value !== undefined && params.value !== null) returnValue = Formatters.secondsToTimeConverterForExcel(params.node.data.GPSLastLock); break;

                case 'IgnitionOn': if (params.value !== undefined && params.value !== null) returnValue = Formatters.gensetSwitchFormatterForExcel(params.value); break;

                case 'CustomerName':
                    {
                        if (params.column.colDef.headerName === 'Assigned To')
                            returnValue = Formatters.stringTypeFormatterFor3PExcel(params.value);
                        else
                            returnValue = params.value;
                    }
                    break;

                case "RSSI": if (params.value !== undefined && params.value !== null) returnValue = params.node.data.RSSI; break;

                case "GetFileRepositoryActionDesc":
                    {
                        returnValue = Formatters.GetFileRepositoryActionDesc(params.value);
                    }
                    break;

                case "RunState": returnValue = Formatters.runStateFormatterforExcel(params.node.data.RunState.toUpperCase().trim()); break;

                case 'Status':
                    {
                        if (params.node.data.Status != undefined || params.node.data.Status != "-NA-" && params.node.data.Status != null)
                            returnValue = params.node.data.Status.trim();
                        else
                            returnValue = "-NA-";
                    }
                    break;

                case "RcdPowerSourceCd": returnValue = Formatters.rcdPowerSourceFormatterforExcel(params.value); break;

                case 'ManufacturedDate':
                    {
                        returnValue = Formatters.YearFromdateTypeFormatterForExcel(params.value);
                    }
                    break;
                case 'AssetType': returnValue = Formatters.AssetTypeFormatterForExcel(params.value);
                    break;

                case 'GensetRunning': {
                    if (params.value !== undefined && params.value !== null) {
                        // Start WI-26787
                        //var HasOilPressureSwitch;
                        //if (params.node.rowIndex !== undefined && params.node.rowIndex !== null
                        //    && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] !== undefined
                        //    && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] !== null) {
                        //    HasOilPressureSwitch = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].HasOilPressureSwitch;
                        //}
                        //else {
                        //    HasOilPressureSwitch = false;
                        //}
                        // End WI-26787
                        //if (HasOilPressureSwitch !== undefined && HasOilPressureSwitch !== null)
                        var isGensetRunning = {
                            GensetRunning: params.node.data.GensetRunning,
                            HasOilPressureSwitch: params.node.data.HasOilPressureSwitch,
                            OEMTypeCD: params.node.data.OEMTypeCD
                        };
                        returnValue = Formatters.EngFormatterforExcel(isGensetRunning);
                    }
                }
                    break;

                case 'DevicePowerSourceCd': {
                    if (params.value !== undefined && params.value !== null) {
                        var DeviceConfig;
                        if (params.node.rowIndex !== undefined && params.node.rowIndex !== null
                            && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] !== undefined
                            && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] !== null) {
                            DeviceConfig = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].DeviceConfig;
                        }
                        else {
                            DeviceConfig = false;
                        }

                        var DeviceType;
                        if (params.node.rowIndex !== undefined && params.node.rowIndex !== null
                            && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] !== undefined
                            && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] !== null) {
                            DeviceType = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].DeviceType;
                        }
                        else {
                            DeviceType = "";
                        }

                        var ispwrStateFormatter = {
                            DeviceType: params.node.data.DeviceConfig,
                            DevicePowerSourceCd: params.node.data.DevicePowerSourceCd,
                            DeviceTypeCd: params.node.data.DeviceType
                        };
                        
                        //if (DeviceType != undefined && DeviceType != null && DeviceConfig != undefined && DeviceConfig != null)
                        returnValue = Formatters.pwrStateFormatterforExcel(ispwrStateFormatter);
                    }
                }
                    break;
                case 'CO2Setpoint': case 'CO2Reading': case 'O2Setpoint': case 'O2Reading': case 'EvaporatorTemp':
                case 'CompositeSuctionPressure': case 'CompressorSuctionTemp': case 'DischargePressure': case 'CompressorDischargeTemp':
                case 'CondenserTemperature': case 'CondenserFanOutPut': case 'LowSpeedEvaporatorFanOutPut': case 'HighSpeedEvaporatorFanOutPut':
                case 'HeaterOnTime': case 'HotGasValveOpening': case 'EconomizerValveOpening': case 'CompressorFrequency': case 'VentPositionSensorCMH':
                case 'TotalCurrentDraw': case 'LineVoltage1': case 'LineVoltage2': case 'LineVoltage3': case 'VFD': case 'LineFrequency':
                    {
                        if (params.value !== undefined && params.value !== null)
                            returnValue = Formatters.sensorDataFormatterforExcel(params.value);
                        else
                            returnValue = "-NA-";
                    }
                    break;
                case 'SetPoint': case 'SupplyTemp1': case 'SupplyTemp2': case 'ReturnTemp1': case 'ReturnTemp2':
                case 'AmbientTemp': case 'EvaporatorTemp': case 'CompressorSuctionTemp': case 'CompressorDischargeTemp':
                case 'CondenserTemperature': case 'USDA1Temp': case 'USDA2Temp': case 'USDA3Temp': case 'Cargo4Temp': case 'SensorSupplyTemp1': case 'SensorReturnTemp1':
                    {
                        if (params.value !== undefined && params.value !== null)
                            returnValue = Formatters.TemperatureFormatterforExcel(params.value);
                        else
                            returnValue = "-NA-";
                    }
                    break
                case 'DeviceTemp': 
                    {
                        if (params !== undefined && params !== null)
                            returnValue = Formatters.TemperatureFormatterExcelForDeviceTemp(params);
                        else
                            returnValue = "-NA-";
                    }
                    break
                case 'TemperatureUnit':
                    {
                        if (params.value !== undefined && params.value !== null)
                            returnValue = Formatters.TemperatureFormatterForBookingforExcel(params.value);
                        else
                            returnValue = "-NA-";
                    }
                    break
                case 'CCSeverityLevel':
                    {
                        if (params.value !== undefined && params.value !== null) {

                            var IsCargoCare = {
                                isCargocare: params.node.data.IsCargoCare,
                                CCSeverityLevel: params.node.data.CCSeverityLevel
                            };
                            returnValue = Formatters.CargoCareFormatterforExcel(IsCargoCare);
                        }
                        else
                            return "-NA-";
                    }
                    break;
                case 'MASeverityLevel':
                    {
                        returnValue = Formatters.statusIndicatorforALMforExcel(params.node.data.MASeverityLevel);
                    }
                    break;
                case 'AlarmsList': returnValue = Formatters.AlarmListFormatterforExcel(params.value); break;
                case 'Humidity':
                    {
                        var isHumidity = {
                            Humidity: params.node.data.Humidity,
                            HumiditySetpointStatus: params.node.data.HumiditySetpointStatus
                        };
                        returnValue = Formatters.HumiditySettingFormatterforExcel(isHumidity);
                    }
                    break;
                case 'CondenserPressure':
                    {
                        var CondenserPressureData = {
                            ReeferOEMTypeCd: params.node.data.ReeferOEMTypeCd,
                            CondenserPressure: params.node.data.CondenserPressure
                        };
                        returnValue = Formatters.sensorDataPCondFormatterExcel(CondenserPressureData);
                    }
                    break;
                case 'EvaporatorExpansionValveOpening':
                    {
                        var EEVData = {
                            ReeferOEMTypeCd: params.node.data.ReeferOEMTypeCd,
                            EvaporatorExpansionValveOpening: params.node.data.EvaporatorExpansionValveOpening
                        };
                        returnValue = Formatters.sensorDataOpenExpFormatterExcel(EEVData);
                    }
                    break;
                case 'SuctionModulationValveOpening':
                    {
                        var SuctionModulationValveOpeningData = {
                            ReeferOEMTypeCd: params.node.data.ReeferOEMTypeCd,
                            SuctionModulationValveOpeningQualifier: params.node.data.SuctionModulationValveOpeningQualifier,
                            SuctionModulationValveOpening: params.node.data.SuctionModulationValveOpening
                        };
                        returnValue = Formatters.sensorDataOpenSucFormatterForExcel(SuctionModulationValveOpeningData);
                    }
                    break;
                case "ThreePhaseCurrent": returnValue = Formatters.Current3PhaseFormatterforExcel(params.value); break;
                case "FilerepositoryActionCD":
                    {
                        if (params.value !== null && params.value !== undefined && params.value !== '' && params.value !== "null")
                            returnValue = Formatters.GetFileRepositoryActionDesc(params.node.data.FilerepositoryActionCD);
                        else
                            return "-NA-";
                    }
                    break;
                case "GPSCoords":
                    return Formatters.GPSCoordsFormatterGroupingForExcel(params);
                case 'HumiditySetpoint':
                    {
                        if (params.value != null && params.value != undefined && params.value != '' && params.value != "null")
                            returnValue = Formatters.HumiditySetpointForExcel(params.value, params.node.data.HumiditySetpointStatus);
                        else
                            return "-NA-";

                        //returnValue = Formatters.HumiditySetpointForExcel(params.value);
                    }
                    break;
                case 'DoorOpen':
                    {
                        if (params.value != undefined && params.value != null) {
                            returnValue = Formatters.DeviceDoorFormatterExcel(params.value);
                        }
                    }
                    break;
                case 'Auth0_OrgId':
                    {
                            returnValue = Formatters.Auth0MigratedYesNoConverterForExcel(params.value);

                    }
                    break;
                default: {
                    if (params.value !== null && params.value !== undefined && params.value !== '' && params.value !== "null") {
                        returnValue = params.value;
                    }
                    else if (params.column.colId === "0") {
                        return "";
                    }
                    else
                        returnValue = "-NA-";
                }
            }

            return returnValue;
        }
    }

    myRowGroupCallback(params) {

        var indent = '--';
        var node = params.node;
        //var label = node.key.toUpperCase();

        var label = self.getGroupDisplayValueName(params);
        if (!node.parent.parent) {
            return label; // top level node, parent is root node
        }
        label = '> ' + label;
        // indent once per level in the row group hierarchy
        while (node.parent.parent) {
            label = indent + label;
            node = node.parent;
        }
        return label;

    } 

    myHeaderCallback(params) {

        var headerDisplayName = params.column.getColDef().headerName;
        switch (headerDisplayName) {
            case "Event Time": case "Reported Time": case "Created On": case "Last Modified On": case "Last Updated On": case "Updated On": case "Created Time": case "Modified Time":
            case 'StatusDate': case 'Submitted Dt': case 'Expiration Dt': case 'Status Time': case 'Submitted Time': case 'Expiration Time': case 'Created on': case 'Updated on': case "Door time":
            case "Event time": case "Receipt time"://RCNG-1143
                return Formatters.TimeZoneFormatter(headerDisplayName);
            case "Device temp. ": case "Device temp "://RCNG-1143
                return Formatters.TemperatureHeaderFormatter(headerDisplayName);            
            default:
                return headerDisplayName;
        }
    }

    myGroupHeaderCallback(params) {

        var displayName = params.columnApi.getDisplayNameForColumnGroup(
            params.columnGroup
        );
        return displayName;
    }

    SendEmailToUser() {
        var uri;
        var isLimitNumberOfEmailsReached: boolean = false;
        if (this.state.EmailFilters.SelectedTo !== undefined || this.state.EmailFilters.SelectedTo !== "") { // WI-26789
            var SendTo = this.state.EmailFilters.SelectedTo;
            var SendFrom = this.state.EmailFilters.SelectedForm;
            var SendToArray = SendTo.split(",");
            var validemail = true;
            var myEmailVLD = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9\-\.])+\.([A-Za-z]{2,4})$/;
            if (SendToArray !== null && SendToArray !== undefined && SendToArray.length < Config.SendEmailLimit) {
            if (SendToArray !== null && SendToArray !== undefined && SendToArray.length > 0) {
                for (var i = 0; i < SendToArray.length; i++) {
                    var valid = myEmailVLD.test(SendToArray[i]);
                    if (!valid) {
                        validemail = false;
                    }
                }
            }
            }
            else {
                isLimitNumberOfEmailsReached = true;
                validemail = false;
            }

            if (validemail) {
                if ((this.state.confirmOk === false) && (this.state.EmailFilters.SelectedSubject === "" || this.state.EmailFilters.SelectedMessage === "")) {
                    this.setState({
                        confirmOk: true
                    });
                    if (this.state.EmailFilters.SelectedSubject === "" && !(this.state.EmailFilters.SelectedMessage === ""))
                        var confirmationMessage = "Are you sure you want to send email without Subject";
                    else if (!(this.state.EmailFilters.SelectedSubject === "") && (this.state.EmailFilters.SelectedMessage === ""))
                        var confirmationMessage = "Are you sure you want to send email without Message?";
                    else if (this.state.EmailFilters.SelectedSubject === "" && (this.state.EmailFilters.SelectedMessage === ""))
                        var confirmationMessage = "Are you sure you want to send email without Subject and Message?";
                    RCNGWindow.ConfirmWindow.showConfirmBox(confirmationMessage, this.SendEmailToUser.bind(this), this.closeConfirmation.bind(this));
                }
                else {
                    this.setState({
                        confirmOk: false
                    });
                    RCNGWindow.ConfirmWindow.close();

                    if (this.props.parentchild === "P") {
                        //uri = Excel.SendmailExportParent(this.props.reeferStatusResult, this.props.columnDefinition, this.props.formname);
                        uri = this.SendEmailExportAPI();
                    }
                    else if (this.props.parentchild === "S") {
                        //uri = Excel.SendmailExportParent(this.props.reeferStatusResult, this.props.columnDefinition, this.props.formname);
                        uri = this.SendEmailExportAPIForAction();
                    }
                    else {
                        //uri = Excel.SendmailExport(this.props.reeferStatusResult, this.props.columnDefinition, this.props.formname);
                        uri = this.SendEmailExportAPI();
                    }
                    this.state.EmailFilters.SelectedForm = this.props.formname;
                    this.state.EmailFilters.SelectedAttachment = uri; //JSON.stringify(uri);
                    var filterParams = JSON.stringify(this.state.EmailFilters);
                    $('#globalLoader').show();
                    var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Email/SendEmailWithGroup', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } })
                    //fetch(request)
                    //    .then(response => response)
                    RCUtils.fetchRetry(request)
                        .then(RCUtils.handleResponse)
                        .then(response => response.json() as Promise<any>)
                        .then(data => {
                            //$('#sendEmail .close').click();
                            $('#sendEmail .btn-close').click();
                            $('#globalLoader').hide();
                            if (this.props.formname === undefined || this.props.formname === null || this.props.formname === undefined || this.props.formname === 'undefined') {
                                $("#contextMenuModel .btn-close").click();
                                $("#EmailGroupModal .btn-close").click();
                            }
                            else if ((this.props.formname.trim() === "ReeferFileRepositoryGrid")) {
                                $("#ReeferFRContextMenu .btn-close").click();
                            }
                            else if ((this.props.formname.trim() === "GeofenceFileRepositoryGrid")) {
                                $("#GeofenceFRContextMenu .btn-close").click();
                            }
                            else if ((this.props.formname.trim() === "RCDFileRepositoryGrid")) {
                                $("#RCDFRContextMenu .btn-close").click();
                            }
                            else if ((this.props.formname.trim() !== "ReeferCommands") && (this.props.formname.trim() !== "TripStatus") && (this.props.formname.trim() !== "LastPreTrip") && (this.props.formname.trim() !== "PreTrip") && (this.props.formname.trim() !== "SchedulePreTrip") && (this.props.formname.trim() !== "StopPTI")) {
                                $("#contextMenuModel .btn-close").click();
                                $("#EmailGroupModal .btn-close").click();
                            }

                            $('#' + this.props.formname + ' .close').click();
                            $('#PopupEmailTo').hide();
                            $('#dashBoardEmailPopUp').hide();
                            $('#' + this.props.formname).hide();
                            PopupWindow.showErrorMessage("Information", data);// "Email Sent Successfully.");
                        })
                        .catch(err => {
                            $('#globalLoader').hide();
                            $('#PopupEmailTo').hide();
                            $('#dashBoardEmailPopUp').hide();
                            $('#' + this.props.formname).hide();
                            PopupWindow.showErrorMessage("Error", "Error Occurred. Please try again.")
                        });
                }
            }
            else {
                if (isLimitNumberOfEmailsReached) {
                    PopupWindow.showErrorMessage("Alert", "Please check the recipient email id. The recipients email should not be more than " + Config.SendEmailLimit + ".");
                    isLimitNumberOfEmailsReached = false;
                }
                else
                PopupWindow.showErrorMessage("Error", "Please verify entered email addresse(s).");
            }
        }
        else {
            PopupWindow.showErrorMessage("Error", "Please enter email address.");
        }
    }

    static ClearFiltersGenset() {
        self.clearEmailFiltersGenset();
    }

    public render() {
        return <div className='sendEmail-footer'>
            <div className='row'>
                <div className="col-md-12" id='alert-msg-email'>
                    <div className="alert alert-warning">
                        <span className='glyphicon glyphicon-exclamation-sign font-size-20 float-start'></span>
                        <div className='alert-text'><strong>Note:</strong> Enter multiple email addresses separated by comma(,)</div>
                    </div>
                </div>
            </div>
            <div className='row mt-1'>
                <div className="col-md-3 col-lg-3 col-sm-3 col-xs-3 text-sm-end pe-0">
                    <label className='col-form-label'>To </label></div>
                <div className="col-md-8 col-lg-8 col-sm-8 col-xs-8">
                    <input type='email' name='SelectedTo' className='form-control' onChange={e => this.ToEmailchange(e)} value={this.state.EmailFilters.SelectedTo} />
                </div>
            </div>
            <div className='row mt-1'>
                <div className="col-md-3 col-lg-3 col-sm-3 col-xs-3 text-sm-end pe-0">
                    <label className='col-form-label'>From: </label></div>
                <div className="col-md-8 col-lg-8 col-sm-8 col-xs-8">
                    <input type='text' name='SelectedFrom' className='form-control' value={this.state.EmailFilters.SelectedFrom} disabled />
                </div>
            </div>
            <div className='row mt-1'>
                <div className="col-md-3 col-lg-3 col-sm-3 col-xs-3 text-sm-end pe-0">
                    <label className='col-form-label'>Subject: </label></div>
                <div className="col-md-8 col-lg-8 col-sm-8 col-xs-8">
                    <input type='text' name='SelectedSubject' className='form-control' onChange={e => this.Subjectchange(e)} value={this.state.EmailFilters.SelectedSubject} />
                </div>
            </div>
            <div className='row mt-1'>
                <div className="col-md-3 col-lg-3 col-sm-3 col-xs-3 text-sm-end pe-0">
                    <span className='float-end normal-font'>Attachment: </span></div>
                <div className="col-md-8 col-lg-8 col-sm-8 col-xs-8">
                    <span className='normal-font float-start'>{this.props.formname}  {this.state.dateTime}</span>
                </div>
            </div>
            <div className='row mt-1'>
                <div className="col-md-3 col-lg-3 col-sm-3 col-xs-3 text-sm-end pe-0">
                    <label className='col-form-label'>Message: </label>
                </div>
                <div className="col-md-8 col-lg-8 col-sm-8 col-xs-8">
                    <textarea id='txtMessage' className='form-control texarea-100' onChange={e => this.Messagechange(e)} value={this.state.EmailFilters.SelectedMessage} ></textarea>
                </div>
            </div>
            <div className='modal-footer mt-3'>
                <button type='button' className='btn btn-primary' onClick={this.SendEmailToUser.bind(this)}>Send</button>
            </div>
        </div>
    }
}

class EmailFields {
    SelectedTo: string;
    SelectedFrom: string;
    SelectedSubject: string;
    SelectedAttachment: string;
    SelectedMessage: string;
    SelectedForm: string;
}